//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "CategoryCollectionsGrid",
  components: {
    Button: () => import("@/components/common/Button/index.vue"),
    Empty: () => import("@/components/common/Empty/index.vue"),
    Section: () => import("@/components/common/Section/index.vue")
  },
  computed: {
    ...mapGetters({
      page: 'pages/category-collections/page',
      entity: 'pages/category-collections/entity',
      empty: 'pages/category-collections/empty',
      items: 'pages/category-collections/items',
      pending: 'pages/category-collections/pending',
      showNextPageButton: 'pages/category-collections/showNextPageButton'
    }),
  },
  methods: {
    next() {
      if (this.page === null) {
        this.$store.commit('pages/category-collections/clear')
        this.$handleScrollTo()
      }
      this.$store.commit('pages/category-collections/setPage', this.page + 1)
      this.$store.dispatch('pages/category-collections/submit')
    }
  }
}
